export default "__VITE_ASSET__DZz04XwZ__"